/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.components.data').factory('WorkflowExecutionResourceFactory', function ($resource, EndPointService) {
	return $resource(EndPointService.workflowExecutionEndPoint + '/:id',
		{
			id: '@id', fetchLimit: '@fetchLimit',
			fetchOffset: '@fetchOffset',
			workflowId: '@workflowId',
			status: '@status',
			dateProperty: '@dateProperty',
			fromDate: '@fromDate',
			toDate: '@toDate',
			submittedByUserId: '@submittedByUserId'
		},
		{
			start: {
				method: 'POST',
				isArray: false,
				url: EndPointService.workflowExecutionEndPoint + '/:id/start',
				params: {id: '@id'}
			},
			resume: {
				method: 'POST',
				isArray: false,
				url: EndPointService.workflowExecutionEndPoint + '/:id/resume'
			},
			stop: {
				method: 'POST',
				isArray: false,
				url: EndPointService.workflowExecutionEndPoint + '/:id/stop'
			},
			abandon: {
				method: 'POST',
				isArray: false,
				url: EndPointService.workflowExecutionEndPoint + '/:id/abandon'
			},
			getWorkflowExecution: {
				method: 'GET',
				isArray: false,
				url: EndPointService.workflowExecutionEndPoint + '/:id'
			},
			getSubflowExecutions: {
				method: 'GET',
				isArray: true,
				url: EndPointService.workflowExecutionEndPoint + '/:id/subflows',
				params: {
					id: '@id',
					fetchLimit: '1000',
					fetchOffset: '0'
				}
			},
			getExecutionSteps: {
				method: 'GET',
				isArray: true,
				url: EndPointService.workflowExecutionEndPoint + '/:id/steps',
				params: {
					executionId: '@id',
					fetchLimit: '@fetchLimit',
					fetchOffset: '@fetchOffset'
				}
			},
			getExecutionContextData: {
				method: 'GET',
				isArray: true,
				url: EndPointService.workflowExecutionEndPoint + '/:id/contextData',
				transformResponse: function (data) {
					var contextDataArray = [];
					angular.forEach(angular.fromJson(data), function (contextValue, contextKey) {
						contextDataArray.push({
							name: contextKey,
							value: (Array.isArray(contextValue)) ? JSON.stringify(contextValue) : contextValue
						});
					});
					return contextDataArray;
				}
			},
            createPackageSnapshot: {
                method: 'POST',
                isArray: false,
                url: EndPointService.workflowExecutionEndPoint + '/createImageFromVideo',
                params: {
                    packageId: '@packageId',
                    frameOffset: '@frameOffset',
                }
            },
			startInstanceDelivery: {
				method: 'POST',
				isArray: false,
				url: EndPointService.workflowExecutionEndPoint + '/startDelivery'
			}
		});
});
